import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";
import {withRouter} from "../../lib/react/withRouter";
import sso from "../../sso";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Reg_Home extends React.Component {
  constructor(props, context) {
    super(props);

    this.store = props.store;
    this.pos = props.store.pos;
    this.state = { pgid: 11, tra: [] };
    this.state.seldate = new Date();
    this.state.avd = "01";
    this.state.paa = [];
    this.state.aa = [];

      this.state.mna = [];
      this.state.mna.push({ mnid: "mn01", pos: "c1", text: "KUNDER", desc: "Kund register", link: "/bcs/reg/kreg" });
      this.state.mna.push({ mnid: "mn01", pos: "c1", text: "LEVERANTÖRER", desc: "Leverantörs register", link: "/bcs/reg/lreg" });
      this.state.mna.push({ mnid: "mn02", pos: "c2", text: "SERVRAR", desc: "Server register", link: "/bcs/reg/srvs" });
      this.state.mna.push({ mnid: "mn02", pos: "c2", text: "SYSTEM", desc: "System register", link: "/bcs/reg/sreg" });
      this.state.mna.push({ mnid: "mn03", pos: "c2", text: "ANVÄNDARE", desc: "Användar register", link: "/bcs/reg/ureg" });
      this.state.mna.push({ mnid: "mn03", pos: "c2", text: "UDID", desc: "Udid register", link: "/bcs/reg/udid" });
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
  }

    mnc(pos) {
        var mna = [];
        for(var row of this.state.mna) {
            if(row.pos == pos) mna.push( row );
        }
        return mna;
    }
  fknGo(url) {
    //alert(row.href);
      var row = {};
      row.url = url;
      sso.seo.sfkn = row;
    this.props.navigate(url);
  }

  render() {
    return (
    <div className="web-app">
        <div className="web-pg py-4 flex">
            <h3>Register</h3>
            <p>Register funktioner</p>

            <div className="divider_green"></div>

            <div className="web-row">
                <div className="flex-col flex">
                    { this.mnc("c1").map((row, key) =>
                        <div className="web-bx" onClick={() => this.fknGo(row.link) }>
                            <div>{ row.text }</div>
                            <div className="flex-row">
                                <div className="flex">{ row.desc }</div>
                                <div className="web-link">Välj</div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="flex-col flex">
                    { this.mnc("c2").map((row, key) =>
                        <div className="web-bx" onClick={() => this.fknGo(row.link) }>
                            <div>{ row.text }</div>
                            <div className="flex-row">
                                <div className="flex">{ row.desc }</div>
                                <div className="web-link">Välj</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>

    </div>
  );
    }
}
export default withRouter(Reg_Home);
